import { pickLocalized, type Locale } from "@/lib/i18n";
import { StarRating, TestimonialsCarousel } from "@/components/TestimonialsCarousel";
import { urlFor } from "@/lib/sanity";

export function TestimonialsSection({
  testimonials,
  locale,
}: {
  testimonials: any[] | undefined;
  locale: Locale;
}) {
  if (!testimonials?.length) return null;

  return (
    <section className="px-4 md:px-[60px]">
      <div className="rounded-[24px] px-6 py-16 md:px-16 md:py-24">
        <h2 className="mx-auto max-w-3xl text-center font-display text-[28px] font-semibold leading-[1.15] text-text-primary md:text-[36px] md:leading-[1.2]">
          {locale === "fr"
            ? "Nos membres avancent avec plus de sérénité et de confiance"
            : "Members are enjoying a steadier and more confident path"}
        </h2>
        <TestimonialsCarousel items={testimonials} locale={locale} />
        <div className="mt-12 hidden gap-8 md:grid md:grid-cols-3">
          {testimonials.map((q: any, i: number) => {
            const quote = pickLocalized(q.quote, locale);
            return (
              <figure
                key={q._key ?? i}
                className="flex flex-col gap-4 rounded-[24px] bg-background-sand p-6"
              >
                <StarRating />
                {quote && (
                  <blockquote className="text-[14px] italic text-text-secondary">
                    &ldquo;{quote}&rdquo;
                  </blockquote>
                )}
                <figcaption className="mt-auto flex items-end gap-3 pt-4">
                  {q.avatar ? (
                    <img
                      src={urlFor(q.avatar).width(100).height(100).fit("crop").url()}
                      alt={q.name ? `${q.name}` : ""}
                      className="h-[50px] w-[50px] rounded-full object-cover"
                    />
                  ) : (
                    <div className="h-[50px] w-[50px] rounded-full bg-secondary-300" aria-hidden />
                  )}
                  {q.name && (
                    <span className="font-sans text-[14px] uppercase tracking-[0.2em] text-text-secondary">
                      {q.name}
                    </span>
                  )}
                </figcaption>
              </figure>
            );
          })}
        </div>
      </div>
    </section>
  );
}
